import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { ref, onValue, off } from 'firebase/database';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let userUnsubscribe = null;
    let adminUnsubscribe = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      // Clean up previous listeners
      if (userUnsubscribe) userUnsubscribe();
      if (adminUnsubscribe) adminUnsubscribe();

      setCurrentUser(user);

      if (user) {
        const userRef = ref(db, 'users/' + user.uid);
        const adminRef = ref(db, 'admins/' + user.uid);

        let userData = null;
        let adminData = null;

        const syncProfile = () => {
          let profileData = {};
          if (userData) profileData = { ...userData };
          if (adminData) {
            profileData = {
              ...profileData,
              isAdmin: true,
              adminId: adminData.adminId,
              role: adminData.role,
              email: adminData.email,
              name: adminData.name || profileData.name
            };
          }
          
          if (Object.keys(profileData).length > 0) {
            setUserProfile(profileData);
          } else {
            setUserProfile(null);
          }
        };

        // Real-time listener for User Profile
        userUnsubscribe = onValue(userRef, (snapshot) => {
          const data = snapshot.exists() ? snapshot.val() : null;
          userData = data;
          syncProfile();
          setLoading(false);
        });

        // Real-time listener for Admin Status
        adminUnsubscribe = onValue(adminRef, (snapshot) => {
          adminData = snapshot.exists() ? snapshot.val() : null;
          syncProfile();
        });

      } else {
        setUserProfile(null);
        setLoading(false);
      }
    });

    return () => {
      unsubscribeAuth();
      if (userUnsubscribe) userUnsubscribe();
      if (adminUnsubscribe) adminUnsubscribe();
    };
  }, []);

  const value = {
    currentUser,
    userProfile,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
